import { render, staticRenderFns } from "./RazorpayCheckout.vue?vue&type=template&id=0f22a900&scoped=true"
import script from "./RazorpayCheckout.vue?vue&type=script&lang=js"
export * from "./RazorpayCheckout.vue?vue&type=script&lang=js"
import style0 from "./RazorpayCheckout.vue?vue&type=style&index=0&id=0f22a900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22a900",
  null
  
)

export default component.exports